import React, { useState } from "react";
import { Upload, CheckCircle, FileText } from "lucide-react";

const StepDocuments = ({ formData, setFormData }) => {
  const [touched, setTouched] = useState({});

  // ✅ Removed double localStorage read/write — MultiStepForm owns that

  const documents = formData?.documents || {};

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({ ...prev, documents: { ...prev.documents, [name]: files[0] } }));
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  // ✅ Fixed: idDocument is required when the user HAS an identification number
  const hasIdNumber = Boolean(formData.personal?.identificationNumber);
  const errors = { idDocument: hasIdNumber && !documents.idDocument };

  const labelClass = "block text-sm font-medium text-gray-700 mb-1.5";
  const errorText  = "text-xs text-red-500 mt-1 flex items-center gap-1";

  const UploadField = ({ name, label, required, optional }) => {
    const file = documents[name];
    return (
      <div>
        <label className={labelClass}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
          {optional && <span className="ml-1 text-xs text-gray-400 font-normal">(optional)</span>}
        </label>
        <label className={`relative flex items-center gap-3 w-full border-2 border-dashed rounded-xl px-4 py-3 cursor-pointer transition-colors duration-150 ${
          file
            ? "border-green-400 bg-green-50"
            : touched[name] && errors[name]
            ? "border-red-400 bg-red-50"
            : "border-gray-200 hover:border-primary hover:bg-blue-50/30 bg-white"
        }`}>
          <input type="file" name={name} accept=".pdf,.jpg,.png" onChange={handleFileChange} className="sr-only" />
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${file ? "bg-green-100" : "bg-gray-100"}`}>
            {file ? <CheckCircle size={18} className="text-green-600" /> : <Upload size={18} className="text-gray-400" />}
          </div>
          <div className="min-w-0">
            {file ? (
              <>
                <p className="text-sm font-medium text-green-700 truncate">{file.name}</p>
                <p className="text-xs text-green-500">File selected</p>
              </>
            ) : (
              <>
                <p className="text-sm text-gray-500">Click to upload</p>
                <p className="text-xs text-gray-400">PDF, JPG or PNG</p>
              </>
            )}
          </div>
          {file && <FileText size={14} className="ml-auto text-green-400 flex-shrink-0" />}
        </label>
        {touched[name] && errors[name] && <p className={errorText}><span>⚠</span> This document is required.</p>}
      </div>
    );
  };

  return (
    <section className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-xl p-4 sm:p-6 md:p-8 space-y-6">
      <div>
        <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-1">
          Section D: Upload Documents
        </h2>
        <p className="text-gray-500 text-sm">
          Upload all necessary documents. Accepted formats: PDF, JPG, PNG. Max 5MB per file.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
        <UploadField name="idDocument"       label="ID / Birth Certificate"    required={hasIdNumber} />
        <UploadField name="guardianDocument" label="Guardian ID Document"      optional />
        <div className="sm:col-span-2">
          <UploadField name="otherDocument"  label="Other Supporting Document" optional />
        </div>
      </div>
    </section>
  );
};

export default StepDocuments;